'use client';

import {
  CaseStudyBody,
  CaseStudyResultsTable,
} from '@/components/case-study/case-study-body';
import { CaseStudyHero } from '@/components/case-study/case-study-hero';
import { CustomerVideos } from '@/components/sections/customer-videos';
import Testimonials from '@/components/sections/testimonials';
import { useTranslation } from '@/lib/i18n/context';

const TicketSwapCaseStudy = () => {
  const { t, isRTL } = useTranslation();
  return (
    <>
      <CaseStudyHero
        customerName="TicketSwap"
        title={
          t.customerStories[
            'How TicketSwap automated 67% of 19 million user support operations'
          ]
        }
        subtitle={
          t.customerStories[
            "Open's AI agent investigates buyer and seller disputes, takes fair action, and resolves issues in under 30 seconds. Handles 10x volume spikes during events automatically."
          ]
        }
        stats={[
          { value: isRTL ? '١٩ مليون' : '19M', label: t.customerStories.users },
          {
            value: isRTL ? '٧٨٪' : '78%',
            label: t.customerStories['Automation rate'],
          },
          {
            value: isRTL ? t.customerStories['All-time high'] : 'ATH',
            label: t.customerStories['CSAT score'],
          },
        ]}
        videoSrc="/home/stories/ticketswap.mp4"
        videoStartAt={2.26}
      />

      <CaseStudyBody
        aside={{
          logoSrc: '/logos/logo-ticketswap.svg',
          logoAlt: 'TicketSwap',
          company: t.customerStories['ticketswap_company_description'],
          industry: t.customerStories['Events & Ticketing'],
          websiteUrl: 'https://www.ticketswap.com',
          keyResults: [
            t.customerStories['• 67.7% automation rate'],
            t.customerStories['• All-time high CSAT score'],
            t.customerStories['• Sub-30 second response time'],
            t.customerStories['• Email, phone, and chat covered'],
          ],
        }}
      >
        <p>{t.customerStories['ticketswap_intro']}</p>

        <h2>{t.customerStories['ticketswap_marketplace_title']}</h2>
        <p>{t.customerStories['ticketswap_marketplace_p1']}</p>
        <p>{t.customerStories['ticketswap_marketplace_p2']}</p>
        <p>{t.customerStories['ticketswap_marketplace_p3']}</p>
        <p>{t.customerStories['ticketswap_marketplace_p4']}</p>

        <h2>{t.customerStories['ticketswap_solution_title']}</h2>
        <p>{t.customerStories['ticketswap_solution_p1']}</p>
        <p>{t.customerStories['ticketswap_solution_p2']}</p>
        <p>{t.customerStories['ticketswap_solution_p3']}</p>
        <p>{t.customerStories['ticketswap_solution_p4']}</p>

        <h3>{t.customerStories['The Results']}</h3>
        <p>{t.customerStories['ticketswap_results_intro']}</p>

        <CaseStudyResultsTable
          metricLabel={t.customerStories['Metric']}
          impactLabel={t.customerStories['Impact']}
          rows={[
            {
              metric: t.customerStories['Automation rate'],
              impact: isRTL ? '٧٨٪' : '78%',
            },
            {
              metric: t.customerStories['CSAT score'],
              impact: t.customerStories['All-time high'],
            },
            {
              metric: t.customerStories['Response time'],
              impact: t.customerStories['Under 30 seconds'],
            },
            {
              metric: t.customerStories['Channels covered'],
              impact: t.customerStories['Email, phone, and chat'],
            },
          ]}
        />

        <p>{t.customerStories['ticketswap_results_p1']}</p>

        <h2>{t.customerStories['ticketswap_impact_title']}</h2>
        <p>{t.customerStories['ticketswap_impact_p1']}</p>
        <p>{t.customerStories['ticketswap_impact_p2']}</p>
        <p>{t.customerStories['ticketswap_impact_p3']}</p>
      </CaseStudyBody>

      <CustomerVideos />

      <Testimonials />
    </>
  );
};

export default TicketSwapCaseStudy;
